import type { FeatureRoute } from '../types';
import { QuotationDetailPage } from './QuotationDetailPage';
import { EditQuotationPage, NewQuotationPage } from './QuotationEditorPage';
import { QuotationsListPage } from './QuotationsListPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'quotations', element: <QuotationsListPage /> },
  { path: 'quotations/new', element: <NewQuotationPage /> },
  { path: 'quotations/:id', element: <QuotationDetailPage /> },
  { path: 'quotations/:id/edit', element: <EditQuotationPage /> },
];
